
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { ROUTES } from "@/router/constants";
import { SHUTDOWN_ACTIONS, SHUTDOWN_GETTERS } from "@/store/shutdown";
import SHUTDOWN from "@/constants/shutdown";
import formatterHelper from "@/helpers/formatter";

export default {
  name: "ShutdownBanner",
  setup() {
    const store = useStore();
    const route = useRoute();

    const loaded = computed(() => store.getters[SHUTDOWN_GETTERS.LOADED]);
    const deadline = computed(() => store.getters[SHUTDOWN_GETTERS.DEADLINE]);
    const isShutDown = computed(() => store.getters[SHUTDOWN_GETTERS.IS_SHUT_DOWN]);

    const show = computed(() => ROUTES.shutdown !== route.name);

    const now = ref(Math.floor(Date.now() / 1000));
    let tickInterval = null;
    let refreshInterval = null;

    onMounted(() => {
      store.dispatch(SHUTDOWN_ACTIONS.REFRESH);

      tickInterval = setInterval(() => {
        now.value = Math.floor(Date.now() / 1000);
      }, 1000);

      refreshInterval = setInterval(() => {
        store.dispatch(SHUTDOWN_ACTIONS.REFRESH);
      }, SHUTDOWN.REFRESH_INTERVAL);
    });

    onBeforeUnmount(() => {
      clearInterval(tickInterval);
      clearInterval(refreshInterval);
    });

    const formattedRemaining = computed(() => {
      if (null === deadline.value) {
        return "";
      }

      const remaining = Math.max(0, deadline.value - now.value);

      const days = Math.floor(remaining / 86400);
      const hours = Math.floor((remaining % 86400) / 3600);
      const minutes = Math.floor((remaining % 3600) / 60);
      const seconds = Math.floor(remaining % 60);

      if (days > 0) {
        return `${days}d ${hours}h ${minutes}m ${seconds}s`;
      }

      if (hours > 0) {
        return `${hours}h ${minutes}m ${seconds}s`;
      }

      return `${minutes}m ${seconds}s`;
    });

    const startDateLabel = computed(() => formatterHelper.formatDateTime(SHUTDOWN.GENESIS_TIMESTAMP));

    // Strip trailing zeros (1 instead of 1.00, but 0.1 stays 0.1) so this reads naturally
    // regardless of how VUE_APP_SHUTDOWN_BONUS_HOURS_PER_TX is set.
    const bonusHoursLabel = parseFloat(SHUTDOWN.BONUS_HOURS_PER_TRANSACTION.toFixed(2)).toString();

    return {
      show,
      loaded,
      isShutDown,
      formattedRemaining,
      startDateLabel,
      bonusHoursLabel,
    };
  },
};
